import {faPlus} from '@fortawesome/free-solid-svg-icons';
import React, {useContext, useState} from 'react';
import {Button, Modal, Spinner} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {AddProps} from '../models/table-models';
import {CustomButton} from './CustomButton';
import {Role} from '../utils/Enums/Roles';
import {AuthContext} from '../context/AuthContext';

interface AddActionComponentProps {
    title: string;
    buttonClass?: string;
    accessActionRoles?: Role[];
    addComponent: ({setShowModal, itemRelatedId}: AddProps) => JSX.Element;
    customButton?: (showModal: () => void) => JSX.Element;
    itemRelatedId?: number;
    refetchEntitiesHook: () => void;
    size?: 'sm' | 'lg' | 'xl';
    isLoading?: boolean;
    setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    customClasses?:string;
    dialogClassName?: string;
    centered?: boolean;
    wrapperClassName?: string;
}

export const AddActionComponent = ({
                                       title,
                                       addComponent,
                                       accessActionRoles,
                                       buttonClass = '',
                                       customButton,
                                       refetchEntitiesHook,
                                       itemRelatedId,
                                       size = "lg",
                                       isLoading,
                                        setIsLoading,
                                        customClasses,
                                         dialogClassName,
                                         centered = true,
                                        wrapperClassName = 'w-100',
                                   }: AddActionComponentProps) => {
    const [showModal, setShowModal] = useState(false);
    const [completeButtonDisabled, setCompleteButtonDisabled] = useState(false);
    // Диалогът може да преименува бутона си - „Генерирай задължение" при месечното фактуриране.
    const [submitLabel, setSubmitLabel] = useState<string | undefined>();
    // Работи ли диалогът в момента. Дотук setIsLoading пътуваше надолу непокътнат, но нито един викащ
    // не го подава, тоест всяко setIsLoading(true) в диалозите падаше на празно и бутонът стоеше готов
    // за второ натискане. Стойността се пази тук и се препраща нагоре само ако някой я иска: на екрана
    // със задълженията вдигането ѝ нагоре подменя целия бутон със спинер, тоест размонтира модала по
    // средата на заявката.
    const [childIsLoading, setChildIsLoading] = useState(false);
    const {t} = useTranslation('translation', {keyPrefix: 'common'});
    const AddComponent = addComponent;
    const {hasPermission} = useContext(AuthContext);

    const setChildLoading: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        setChildIsLoading(value);
        setIsLoading?.(value);
    };

    const closeModal = () => {
        setShowModal(false);
        // Затвори ли операторът диалога по средата на заявка, флагът му няма как да се свали сам и
        // следващото отваряне би заварило подложката със спинер вместо с бутон.
        setChildIsLoading(false);
    };

    return (
        <div className={wrapperClassName}>
            {customButton ? (
                <>{customButton(() => setShowModal(true))}</>
            ) : (
                <CustomButton
                    disabled={accessActionRoles && !hasPermission([...accessActionRoles, Role.ADMIN])}
                    icon={faPlus}
                    title={title}
                    iconClass='me-2'
                    onClick={() => setShowModal(true)}
                    className={`btn-success text-nowrap outline-none px-4 ${buttonClass}`}
                />
            )}
            <Modal show={showModal} onHide={closeModal} backdrop="static" size={size} centered={centered} className='custom-modal' dialogClassName={dialogClassName}>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={`${customClasses || ''}`}>
                    {showModal && (
                        <AddComponent
                            setShowModal={setShowModal}
                            itemRelatedId={itemRelatedId}
                            setIsLoading={setChildLoading}
                            {...{refetchEntitiesHook, setCompleteButtonDisabled, setSubmitLabel}}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button onClick={closeModal}>{t('close')}</Button>
                    {/* Спинерът стоеше в <tr><td> вътре в подложката - невалиден HTML, който React
                        отхвърля. Дотук не се виждаше, защото никой не вдигаше isLoading. */}
                    {isLoading || childIsLoading ?
                        <div className='align-self-center'>
                            <Spinner animation='border'/>
                        </div> :
                        <Button disabled={completeButtonDisabled} form='form' type='submit' className='btn-success'>
                            {submitLabel ?? t('save')}
                        </Button>}
                </Modal.Footer>
            </Modal>
        </div>
    );
};
